import { Component, Input, OnInit, EventEmitter, Output, Inject } from "@angular/core";
import { CommonService } from "../../_services/common.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { heroes } from "../../mnt-settings/data-model";
import { environment } from '../../../environments/environment';
import { ImageCropperComponent } from '../../shared/image-cropper/image-cropper.component';

export interface DialogData {
  storeData: any;
}
@Component({
  selector: 'app-create-store',
  templateUrl: './create-store.component.html',
  styleUrls: ['./create-store.component.css'],
  providers: [DatePipe]
})
export class CreateStoreComponent implements OnInit {
  public createStoreForm: FormGroup;
  userList: Array<any> = [];
  searchTextboxControl = new FormControl();
  filteredOptions: Observable<any[]>;
  private clientId: string;
  public logo_image_path: SafeUrl | string = null;
  public header_image_path: SafeUrl | string = null;
  public favicon_image_path: SafeUrl | string = null;
  public selectedFile = null;
  public SelectedHeaderFile = null;
  public SelectedFaviconFile=null;
  public errormsg: string;
  private result = '';
  public isShowMsg = false;
  public activeClass: string;
  public storeUrl: string;
  public  loading = false;
  public isPayLater: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private datepipe: DatePipe,
    private CommonService: CommonService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CreateStoreComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {
    this.storeUrl = '.'+environment.Store_URL;
    this.createStoreForm = this.formBuilder.group({
      storeName: [null, Validators.required],
      storeUrl:[null, Validators.required],
      headline: [null, Validators.required],
      storeType: [null, Validators.required],
      endDate: [null],
      estimateDeliveryDate: [null],
      salesGoal: [null],
      allowLocalPickup: [null, Validators.required],
      isPayLater: ['No', Validators.required],
      clientNotification: ['No', Validators.required],
    });
    if (this.data.storeData) {
      this.activeClass = 'active';
      this.createStoreForm.patchValue({
        'storeName': this.data.storeData.name,
        'storeUrl':this.data.storeData.store_url,
        'headline': this.data.storeData.headline,
        'storeType': this.data.storeData.store_type || 'persistent',
        'endDate': new Date(this.data.storeData.end_date),
        'estimateDeliveryDate': new Date(this.data.storeData.delivery_date),
        'salesGoal': (this.data.storeData.sales_goal && this.data.storeData.sales_goal!='null')?this.data.storeData.sales_goal:'',
        'allowLocalPickup': this.data.storeData.is_local_pickup,
        'isPayLater': this.data.storeData.is_pay_later ? 'Yes' : 'No',
        'clientNotification': this.data.storeData.client_notification ? 'Yes' : 'No',

      });
      if (this.data.storeData.logo) {
        this.logo_image_path = this.data.storeData.logo;
      }
      if (this.data.storeData.header_img)
      {
        this.header_image_path = this.data.storeData.header_img;
      }
      if (this.data.storeData.favicon_img)
      {
        this.favicon_image_path = this.data.storeData.favicon_img;
      }

    } else {
      this.createStoreForm.patchValue({
        'storeType': 'persistent'
      });
    }
  }

  onNoClick() {
    this.dialogRef.close(this.result);
  }
  isFieldValid(field: string) {
    return (
      !this.createStoreForm.get(field).valid &&
      this.createStoreForm.get(field).touched
    );
  }

  getClientList = function (searchText) {

    this.customeItemOptions = {
      id: localStorage.getItem("userID"),
      search: searchText
    };
    this.CommonService.apiService(
      "POST",
      "users/list",
      this.customeItemOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.userList = response.data.records;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
    return this.userList;
  }

  getSelectedValue(clientName) {
    let clientData = this.userList.find(x => x.name === clientName);
    if (clientData) {
      this.clientId = clientData.user_id;
    }

  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    var render = new FileReader();
    render.onload = (event: any) => {
      this.logo_image_path = this.sanitizer.bypassSecurityTrustUrl(event.target.result);

    }
    render.readAsDataURL(this.selectedFile);

  }

  onHeaderFileChanged(event) {
    this.SelectedHeaderFile = event.target.files[0];
    var render = new FileReader();
    render.onload = (event: any) => {
      this.header_image_path = this.sanitizer.bypassSecurityTrustUrl(event.target.result);

    }
    render.readAsDataURL(this.SelectedHeaderFile);

  }
  onFaviconFileChanged(event){
    this.SelectedFaviconFile = event.target.files[0];
    var render = new FileReader();
    render.onload = (event: any) => {
      this.favicon_image_path = this.sanitizer.bypassSecurityTrustUrl(event.target.result);

    }
    render.readAsDataURL(this.SelectedFaviconFile);
  }

  saveStoreData = function (postData) {
    if (this.createStoreForm.valid) {
      this.loading = true;
      let apiName = 'createstore';
      const formData = new FormData();
      if (this.data.storeData && this.data.storeData.store_id) {
        apiName = 'store/edit'
        formData.append('id', this.data.storeData.store_id);
      }
      formData.append('shop_id', localStorage.getItem("userID"));
      formData.append('name', postData.storeName);
      formData.append('store_url', postData.storeUrl);
      formData.append('headline', postData.headline);
      formData.append('is_pay_later', postData.isPayLater);
      formData.append('client_notification', postData.clientNotification);

      if (postData.storeType != 'persistent') {
        formData.append('end_date', this.datepipe.transform(new Date(postData.endDate), 'yyyy-MM-dd hh:mm:ss'));
        formData.append('delivery_date', this.datepipe.transform(new Date(postData.estimateDeliveryDate), 'yyyy-MM-dd hh:mm:ss'));
      }
      
      formData.append('store_type', postData.storeType);
      formData.append('sales_goal', postData.salesGoal);
      formData.append('is_local_pickup', postData.allowLocalPickup);
      if (this.selectedFile) {
        formData.append('logo', this.selectedFile, this.selectedFile.name);
      }
      if (this.SelectedHeaderFile) {
        formData.append('header_img', this.SelectedHeaderFile, this.SelectedHeaderFile.name);
      }
      if (this.SelectedFaviconFile) {
        formData.append('favicon_img', this.SelectedFaviconFile, this.SelectedFaviconFile.name);
      }
      if (!this.logo_image_path) {
        this.loading = false;
        this.isShowMsg = true;
        this.errormsg = "Please upload logo";
        setTimeout(function () {
          this.isShowMsg = false;
        }.bind(this), 5000);
        window.scroll(0, 0);
        return;
      }
      if (!this.header_image_path) {
        this.loading = false;
        this.isShowMsg = true;
        this.errormsg = "Please upload Header image";
        setTimeout(function () {
          this.isShowMsg = false;
        }.bind(this), 5000);
        window.scroll(0, 0);
        return;
      }
      this.CommonService.apiService(
        "POST",
        apiName,
        formData
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            this.result = "success";
            this.onNoClick();
          }
        },
        err => {         
          this.loading = false;
          this.isShowMsg = true;
          this.errormsg = err.error.message;
          setTimeout(function () {
            this.isShowMsg = false;
          }.bind(this), 5000);
          window.scroll(0, 0);
        }

      );
    } else {
      this.validateAllFormFields(this.createStoreForm);
    }
  };

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  openImageCropperDialog(event, maintainAspectRatio, aspectRatio, resizeToWidth, resizeToHeight, section): void {
    if(event.target.files[0] && event.target.files[0].name) {
      const dialogRef = this.dialog.open(ImageCropperComponent, {
        width: "500px",
        disableClose: true,
        data: {
          event: event,
          maintainAspectRatio: maintainAspectRatio,
          aspectRatio: aspectRatio,
          resizeToWidth: resizeToWidth,
          resizeToHeight: resizeToHeight
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.status) {
          if (section == 'favicon') {
            this.favicon_image_path = result.base64;
            this.SelectedFaviconFile = {
              file: result.file,
              name: result.fileName
            };
          } else if (section == 'logo') {
            this.logo_image_path = result.base64;
            this.selectedFile = {
              file: result.file,
              name: result.fileName
            };
          } else if (section == 'header') {
            this.header_image_path = result.base64;
            this.SelectedHeaderFile = {
              file: result.file,
              name: result.fileName
            };
          }
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/create-store/create-store.component.ts